import { Box, Divider, MediaBox, Shimmer } from "@jewlr/storybook/core"
import React from "react"

import { IS_JEWLR } from "helpers/application"

const WizardPricingLoading = () => (
  <Box mb="12px" textAlign={{ _: "center", tablet: "left" }}>
    <Shimmer
      height={IS_JEWLR() ? { _: "82px", tablet: "48px" } : "32px"}
      mb="12px"
      mx={{ _: "auto", tablet: 0 }}
      width={IS_JEWLR() ? "280px" : "80px"}
    />
    {IS_JEWLR() && (
      <>
        {sl.config.use_yotpo && (
          <MediaBox lessThan="tablet" mb="15px" mt={1}>
            <Shimmer height="12px" mx="auto" width="280px" />
            <Divider mt="12px" mx={4} />
          </MediaBox>
        )}
        {sl.config.enable_affirm && (
          <MediaBox lessThan="tablet" mb="10px">
            <Shimmer height="18px" mx="auto" width="280px" />
          </MediaBox>
        )}
        {sl.config.klarna_osm_pdp && (
          <MediaBox lessThan="tablet" mb="10px">
            <Shimmer height="70px" mx="auto" width="280px" />
          </MediaBox>
        )}
        {(sl.config.use_yotpo ||
          sl.config.enable_affirm ||
          sl.config.klarna_osm_pdp) && (
          <MediaBox greaterThanOrEqual="tablet">
            <Shimmer
              height={sl.config.klarna_osm_pdp ? "70px" : "18px"}
              width="100%"
            />
          </MediaBox>
        )}
      </>
    )}
  </Box>
)

export default WizardPricingLoading
